import React from 'react';

import clsx from 'clsx';

import { Textarea } from '@headlessui/react';
import DInputBlock from '@/components/Global/DInput/DInputBlock';

const DTextArea = React.forwardRef(
  (
    {
      children,
      label,
      resize = false,
      error,
      type,
      className,
      labelClassName,
      required,
      minRows = 1,
      autoResize = false,
      value,
      ...props
    },
    ref
  ) => {
    return (
      <DInputBlock label={label} error={error} required={required} labelClassName={labelClassName}>
        <div className="flex flex-col gap-v3-xs w-full">
          <div
            className={clsx(
              className,
              'w-full flex  items-center rounded-v3-xs border-[1px] focus-within:border-black/20 border-black/5 py-v3-xs bg-[--dt-color-surface-100] min-h-11 px-v3-ms gap-v3-xs',
              error && 'border-negative-100',
              autoResize &&
                'grid [&>textarea]:text-inherit after:text-inherit [&>textarea]:resize-none [&>textarea]:overflow-hidden [&>textarea]:[grid-area:1/1/2/2] after:[grid-area:1/1/2/2] after:whitespace-pre-wrap after:invisible after:content-[attr(data-cloned-val)_\'_\'] after:leading-[1.4]'
            )}
            data-cloned-val={value}
          >
            <Textarea
              ref={ref}
              data-testid={`d-textarea-${props.name ?? props.id ?? ''}`}
              rows={autoResize ? 1 : minRows}
              value={value}
              {...props}
              type={type}
              className={clsx(
                'w-full resize-none placeholder-black/20 bg-transparent text-sm data-[focus]:border-black/20',
                'text-min-safe-input',
                resize && 'resize-y',
                autoResize &&
                  `resize-none h-full min-h-[${minRows * 16 * 1.4}px]`
              )}
            />
          </div>
        </div>
      </DInputBlock>
    );
  }
);

DTextArea.displayName = 'DTextArea';

export default DTextArea;

